module.exports = __webpack_public_path__ + "img/testimonials-3.15393c5a.jpg";